var $d085d780952864a7$exports = {};
$d085d780952864a7$exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};


export {$d085d780952864a7$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
